















































































































































/** @format */
import { exportLocalcashDetailExport, localcashDetail } from '../../../api/reconciliation-management/index';

import { Component, Vue, Mixins } from 'vue-property-decorator';

import Utils from '@root/utils/common';
import { payMethodsMap } from '../../../types/order-management/dictionaries';
import TableMixin from '@root/common/mixins/table';

import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';

import moment from 'moment';
import {
  checkTypeMap,
  localPayTypeMap,
  detailReconciliationResultMap
} from '@/types/reconciliation-management/dictionaries';
import PlateInput from '@/components/plate-input/index.vue';
import RangePickerBox from '@/components/range-picker-box/index.vue';

const defalutParams = {
  parkId: [],
  chkDayStart: moment(new Date()).format('YYYY-MM-DD 00:00:00'),
  chkDayEnd: moment(new Date()).format('YYYY-MM-DD 23:59:59'),
  payWay: [],
  // platformTradeNo: '',
  localTradeNo: '',
  // plateHead: '',
  // plateTail: '',
  plate: '',
  result: '',
  checkType: [],
  payChannel: ''
};

@Component({
  name: 'LocalCashDetail',
  components: {
    ParkingLotSearch,
    PlateInput,
    RangePickerBox
  }
})
export default class LocalCashDetail extends Mixins(TableMixin, TableWidthMixin) {
  private payMethodsList = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.local_cash_detail_payway);
  // private payMethodsList = Utils.toLabelVal(localPayTypeMap)
  // 业务类型
  private checkTypeList = Utils.toLabelVal(checkTypeMap);
  public filterParam = { ...defalutParams };
  clearPlate = false;
  private detailReconciliationResultList = Utils.toLabelVal(detailReconciliationResultMap);
  payChannelList = [
    { label: '出口岗亭', value: '00' },
    { label: '移动岗亭', value: '02' },
    { label: '自助缴费机', value: '01' }
  ];
  private sumRowData: any = {};
  clear({ defaultParkIdList }) {
    this.clearPlate = true;
    this.filterParam = {
      parkId: defaultParkIdList,
      ...defalutParams
    };
    this.search();
  }
  get operateTime() {
    if (this.filterParam.chkDayStart && this.filterParam.chkDayEnd) {
      return [
        this.moment(this.filterParam.chkDayStart, 'YYYY-MM-DD'),
        this.moment(this.filterParam.chkDayEnd, 'YYYY-MM-DD')
      ];
    } else if (this.filterParam.chkDayStart) {
      return [this.moment(this.filterParam.chkDayStart, 'YYYY-MM-DD')];
    } else {
      return [];
    }
  }
  set operateTime(val: any) {}
  private tableLoading: boolean = false;
  public tableData: any[] = [];

  private activated() {
    this.init();
    this.fetchTableData();
  }
  private init() {
    const { localTime, parkId } = this.$route.params;
    if (localTime) {
      this.filterParam.chkDayStart = localTime as string;
      this.filterParam.chkDayEnd = localTime as string;
    }
    if (parkId) {
      this.filterParam.parkId = [];
      this.filterParam.parkId.push(parkId as string);
    }
  }

  private search() {
    this.current = 1;
    this.fetchTableData();
  }

  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }
  public async fetchTableData() {
    try {
      // 时间跨度判断拦截 （单车场可跨365天，多车场最多可跨30天）

      const exitEnterTimeoffsetDays = this.filterParam.parkId.length === 1 ? 365 : 30;
      if (
        moment(this.filterParam.chkDayEnd).diff(moment(this.filterParam.chkDayStart), 'days') > exitEnterTimeoffsetDays
      ) {
        this.$message.warn(`查询条件：对账日期，跨度不可超过${exitEnterTimeoffsetDays}天`);
        return;
      }

      if (this.tableLoading) return;
      this.tableLoading = true;
      const {
        parkId,
        chkDayStart,
        chkDayEnd,
        payWay,
        localTradeNo,
        plate,
        payChannel,
        result,
        checkType
      } = this.filterParam;
      const { status, msg, code, data } = await localcashDetail({
        parkId: '' + parkId,
        chkDayStart,
        chkDayEnd,
        // platformTradeNo,
        localTradeNo,
        payWay: '' + payWay,
        currPage: this.current,
        pageSize: this.pageSize,
        plate,
        payChannel,
        result,
        checkType: checkType.join(',')
      });
      if (data) {
        const { pageSize = 0, currPage = 0, totalNum = 0, datas = [], total } = data;
        this.total = Number(totalNum);
        if (datas.length > 0) {
          this.tableData = datas;
          this.sumRowData = total;
          // this.tableData.push({
          //   ...total,
          //   parkName: '合计',
          //   isTotal: true,
          // })
        } else {
          this.tableData = [];
        }
        // this.pageSize = this.pageSize + 1
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  /**
   * 导出
   */
  private async download() {
    try {
      const {
        parkId,
        chkDayStart,
        chkDayEnd,
        payWay,
        localTradeNo,
        plate,
        payChannel,
        result,
        checkType
      } = this.filterParam;
      await exportLocalcashDetailExport(
        {
          parkId: '' + parkId,
          chkDayStart,
          chkDayEnd,
          // platformTradeNo,
          localTradeNo,
          payWay: '' + payWay,
          plate,
          payChannel,
          result,
          checkType: checkType.join(',')
        },
        '本地明细对账'
      );
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }

  private moment = moment;

  private chkDayChange(date: any, dateString: any) {
    let [chkDayStart, chkDayEnd] = dateString;
    this.filterParam.chkDayStart = chkDayStart;
    this.filterParam.chkDayEnd = chkDayEnd;
  }

  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        }
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'parkName' }
      },
      {
        title: '账单时间',
        dataIndex: 'chkDay',
        width: 200
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 140
      },
      {
        title: '对账结果',
        dataIndex: 'result',
        width: 140
      },
      {
        title: '本地交易流水号',
        dataIndex: 'localTradeNo',
        width: 290,
        scopedSlots: { customRender: 'localTradeNo' }
      },
      {
        title: '交易时间',
        dataIndex: 'paidTime',
        width: 200
      },
      {
        title: '收费员',
        dataIndex: 'tollman',
        width: 140
      },
      {
        title: '支付方式',
        dataIndex: 'payWay',
        width: 140
      },
      // {
      //   title: '支付渠道',
      //   dataIndex: 'payChannel',
      // },
      {
        title: '收费金额',
        children: [
          {
            title: '应收金额',
            dataIndex: 'localTotalAmount',
            width: 100,
            customRender: (text: any, record: any, index: number) =>
              Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
          },
          {
            title: '优惠金额',
            dataIndex: 'localDiscountAmount',
            width: 100,
            customRender: (text: any, record: any, index: number) =>
              Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
          },
          {
            title: '应收未收',
            dataIndex: 'localOutstandingAmount',
            width: 100,
            customRender: (text: any, record: any, index: number) =>
              Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
          },
          {
            title: '减免金额',
            dataIndex: 'localRemissionAmount',
            width: 100,
            customRender: (text: any, record: any, index: number) =>
              Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
          },
          {
            title: '实收金额',
            dataIndex: 'localPaidAmount',
            width: 100,
            customRender: (text: any, record: any, index: number) =>
              Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
          }
        ]
      }
    ];
  }

  toDetail() {}
  plateChange([plateHead, plateTail]: any) {
    this.filterParam.plate = plateHead + plateTail;
  }
}
